import { createService, mapServiceCall } from "@/Services/BaseService";
import { mapToLocalTimezone } from "@/Services/Tools/GlobalMapper";
import { mapJobsToDisplay, mapJobLog } from "@/Services/Tools/JobsMapper";

import { getTimeRange } from "@/Modules/utils/dateFormatter";

const JobService = createService("api/Job");

export function startJob(key, organizationUnitId) {
  return JobService.post("/StartJob", { releaseKey: key, organizationUnitId });
}

export function stopJob(jobId, organizationUnitId) {
  return JobService.post("/StopJobs", {
    jobIds: [String(jobId)],
    organizationUnitId,
  });
}

export function restartJob(key, organizationUnitId) {
  return JobService.post("/RestartJob", {
    jobId: String(key),
    organizationUnitId,
  });
}

export function getLogsForJob(tenant, jobKey, organizationUnitId) {
  return JobService.get(
    `/JobLogs?tenant=${tenant}&jobKey=${jobKey}&organizationUnitId=${organizationUnitId}`
  );
}

export function getMappedLogsForJob(tenant, jobKey, organizationUnitId) {
  return mapServiceCall(
    getLogsForJob(tenant, jobKey, organizationUnitId),
    mapJobLog
  );
}

function getJobsInternal(date) {
  let path = `/AllJobsUipath?dateTime=${getTimeRange(date)}`;
  return JobService.get(path);
}

// Return jobs raw except dates are converted
export function getJobs(date) {
  return mapServiceCall(getJobsInternal(date), mapToLocalTimezone);
}

export function getJobsMapped(date) {
  return mapServiceCall(getJobsInternal(date), mapJobsToDisplay);
}

export function getNewestJobs(organizationUnitId, top = 10) {
  return JobService.get(
    `/GetTopJobsFromOrchestrator?tenant=${organizationUnitId}&top=${top}`
  );
}

export function getNewestJobsMapped(organizationUnitId, top = 10) {
  return mapServiceCall(
    getNewestJobs(organizationUnitId, top),
    mapJobsToDisplay
  );
}